import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import ModalWrapper from '@components/modal/ModalWrapper';
import ModalArrowPointer from './../../../../JobCardPreview/ModalArrowPointer';
import { useCalculateModalPosition } from '@v2/pages/planboard/hooks/useCalculateModalPosition';
import { JobCardMenuProps } from '@v2/pages/planboard/components/Board/web/Card/types';
import { PLANBOARD_TILE_CONFIG, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const JobCardMenu: React.FC<JobCardMenuProps> = ({ isOpen, onClose, onOpenJob, onMoveToPosition, onMarkAsFinished, C, scale, font, anchorRef }) => {
  const position = useCalculateModalPosition({ isOpen, anchorRef, scale, modalWidth: PLANBOARD_TILE_CONFIG.MENU_WIDTH });
  const menuWidth = scale(PLANBOARD_TILE_CONFIG.MENU_WIDTH);

  const menuItems = [
    {
      label: i18n.t('Open'),
      onPress: () => {
        onOpenJob();
        onClose();
      },
    },
    ...(onMoveToPosition
      ? [
          {
            label: i18n.t('Move To Position'),
            onPress: () => {
              onMoveToPosition();
              onClose();
            },
          },
        ]
      : []),
    ...(onMarkAsFinished
      ? [
          {
            label: i18n.t('Mark As Finished...'),
            onPress: () => {
              onMarkAsFinished();
              onClose();
            },
          },
        ]
      : []),
  ];

  return (
    <ModalWrapper
      isVisible={isOpen}
      C={C}
      onBackdropPress={onClose}
      backdropColor="transparent"
      backdropOpacity={0}
    >
      <ModalArrowPointer
        position={position}
        scale={scale}
        C={C}
        font={font}
        width={menuWidth}
        maxHeight={position.maxHeight}
        borderRadius={SCREEN_BORDER_RADIUS}
        contentContainerStyle={{
          backgroundColor: C('Background/Light/Field on modal'),
        }}
      >
        {menuItems.map((item, index) => (
          <TouchableElement key={item.label} onPress={item.onPress}>
            {({ pressHoverColor, boxStyle }) => (
              <View
                style={[
                  boxStyle,
                  {
                    paddingVertical: scale(12),
                    paddingHorizontal: scale(16),
                    backgroundColor: C(pressHoverColor('Background/Light/Field on modal')),
                    borderBottomWidth: index < menuItems.length - 1 ? StyleSheet.hairlineWidth : 0,
                    borderBottomColor: C('Hairline/Light/No trans [mobile]'),
                  },
                ]}
              >
                <Text style={[font['Body'], { color: C('Label/Light/Primary') }]}>{item.label}</Text>
              </View>
            )}
          </TouchableElement>
        ))}
      </ModalArrowPointer>
    </ModalWrapper>
  );
};

export default JobCardMenu;
